import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './faktura.module.scss';

export default function FakturaDashboard() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    return (
        <>
            <div className="container">

                <h3>Faktura</h3>

                <div className={styles.cardContainer} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 3fr))", gap: "20px", marginTop: "20px" }}>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("./faktura/rechnungslaufListe")}>
                        <span className={styles.landingPageCardSpan}>
                            Liste Rechnungslaeufe
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("./faktura/listeAbrechenbareDl")}>
                        <span className={styles.landingPageCardSpan}>
                            Liste Abrechenbare Dienstleistungen
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("./faktura/ausgangsrechnungen")}>
                        <span className={styles.landingPageCardSpan}>
                            Ausgangsrechnungen
                        </span>
                    </div>

                     <div className={"card " + styles.landingPageCard} onClick={() => navigate("./faktura/rechnungsnummerAnpassen")}>
                        <span className={styles.landingPageCardSpan}>
                            Rechnungsnummer anpassen
                        </span>
                    </div>
                </div>

            </div>

        </>
    );
}
